import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import { getCleanPathname, addToSetIfTruthy, getParentElement, getElementHeader, getElementText, getElDownloadExitLink, sendAnalytics, getImpressionParentElement, } from './utils.js';
export const setupClickTracking = (createImpression, optionalExtraTrackers = [], customObj = {}) => {
    const eventName = 'click';
    const useCapture = true;
    const elementsToTrack = ['CIPUBLIC-PHONE-NUMBER', 'CIPUBLIC-LINK', 'CIPUBLIC-BUTTON', 'CIPUBLIC-TAB', ...optionalExtraTrackers];
    const callback = (event) => {
        var _a;
        let products = '';
        let thisCustomObj = {};
        if ('composed' in event && typeof event.composedPath === 'function') {
            const path = event.composedPath();
            const targetElement = Array.from(path).find((element) => element instanceof HTMLElement && elementsToTrack.includes(element.tagName));
            const isImpression = getImpressionParentElement(path, true) && getImpressionParentElement(path, true) !== 'body';
            const parentWithCustom = Array.from(path).find((el) => el instanceof HTMLElement && el.hasAttribute('data-custom'));
            (_a = parentWithCustom === null || parentWithCustom === void 0 ? void 0 : parentWithCustom.getAttribute('data-custom')) === null || _a === void 0 ? void 0 : _a.split('^').forEach((prop) => {
                const propArr = prop.split(':');
                propArr[1] = propArr[1].replace(/\*/g, ':');
                propArr[1] = propArr[1].replace(/@%/g, '^');
                thisCustomObj[propArr[0]] = propArr[1];
            });
            thisCustomObj = { ...customObj, ...thisCustomObj };
            if (!targetElement)
                return;
            emit(document.body, 'analytics-click', {
                detail: {
                    event,
                    targetClicked: targetElement,
                    targetHref: targetElement.href || '',
                    targetTag: targetElement.tagName,
                    targetParent: getParentElement(path),
                },
            });
            const info = new Set([getCleanPathname(location.pathname)]);
            isImpression
                ? addToSetIfTruthy(info, getImpressionParentElement(path))
                : addToSetIfTruthy(info, getParentElement(path));
            addToSetIfTruthy(info, getElementHeader());
            addToSetIfTruthy(info, getElementText(targetElement));
            if (isImpression && !optionalExtraTrackers.includes('NOPRODUCTSTRING')) {
                products = createImpression(targetElement, products, path);
            }
            const digitalActions = {
                item: 'clicktracking',
                linkname: getElementText(targetElement),
                component: `${getParentElement(path)}${getElDownloadExitLink(targetElement, true)}`,
                downloadexit: getElDownloadExitLink(targetElement),
                value: [...info].join('|'),
            };
            sendAnalytics('actiontracking', products, digitalActions, thisCustomObj);
            thisCustomObj = {};
        }
    };
    document.addEventListener(eventName, callback, useCapture);
};
//# sourceMappingURL=clicktracking.js.map